import React from "react";
import sanityClient from "../client.js";
import BlockContent from '@sanity/block-content-to-react';
import ListPinballs from "./ListPinballs";
import { motion } from "framer-motion";

const transition = { duration: 0.6, ease: [0.43, 0.13, 0.23, 0.9] };

class Location extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            locationIntro: []
        };
    }

    componentDidMount() { 
        // Get site config
        sanityClient.fetch(`*[_type == 'siteSettings'][0]`)
            .then(data => {
                this.setState({ 
                    locationIntro: data.locationIntro
                });
            })
            .catch(console.error);
    }

    render() {
        return (
            <motion.div className="page" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0, transition: transition }}>
                <div className="container">
                    <div className="row align-items-center justify-content-center my-5">
                        <div className="col-lg-8 framed">
                            <BlockContent blocks={this.state.locationIntro} projectId="552cpgqt" dataset="production" serializers={this.serializers} />
                        </div>
                    </div>
                    <ListPinballs />
                </div>
            </motion.div>
        );
    }
}

export default Location;